// NPM Imports
import React, { Component } from "react";
import { Tooltip } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal Imports
import { DRAFT } from "../../constants";
import { checkInlineBtnStatus } from "../../utils/draftUtils";

// Destructuring
const { TOOLBAR_INLINE_BUTTONS } = DRAFT;

class InlineButtons extends Component {
  _onToggle = (event, type, fontSize) => {
    event.preventDefault();
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
    const { handleButtonClick } = this.props;
    handleButtonClick(type, fontSize);
  };

  onWindowClick = () => {
    this.props.onOverrideContent(undefined);
  };

  render() {
    const { editorState, metaData } = this.props;
    return TOOLBAR_INLINE_BUTTONS.map(btn => {
      let className = "toolbar-custom-inline-button toolbar-btn ";
      const isActive = checkInlineBtnStatus(editorState, btn.type, metaData);
      if (isActive) {
        className += btn.activeClass;
      }
      return (
        <div
          className="draft-edit-items"
          data-test={btn.toolbarID}
          id={btn.toolbarID}
          key={btn.toolbarID}>
          <Tooltip
            placement="top"
            overlay={btn.tooltip}
            align={{
              offset: [3, 0],
            }}>
            <button
              type="button"
              className={className}
              onMouseDown={event => this._onToggle(event, btn.type, null)}
              data-test={`revv-toolbar-inline-btn-${btn.id}`}>
              <i>
                <FontAwesomeIcon icon={["fas", `${btn.icon}`]} />
              </i>
            </button>
          </Tooltip>
        </div>
      );
    });
  }
}

export default InlineButtons;



// WEBPACK FOOTER //
// ./src/components/RevvToolBar/InlineButtons.js